import React from 'react';

export const OfferTableItemSkeleton = () => {
  return (
    <tr className='h-[72px] border-b border-bright-grey'>
      <td className='whitespace-nowrap min-w-fit w-[390px]'>
        <div className='flex gap-3 items-center'>
          <div className='bg-bright-grey rounded-[4px] h-[42px] w-[42px]' />
          <div className='flex flex-col gap-1'>
            <div className='h-[18px] w-[200px] bg-bright-grey rounded' />
            <div className='h-[18px] w-[100px] bg-bright-grey rounded' />
          </div>
        </div>
      </td>
      <td className='whitespace-nowrap min-w-fit w-[233px]'>
        <div className='flex flex-col items-start gap-1'>
          <div className='h-[18px] w-[100px] bg-bright-grey rounded' />
          <div className='h-[18px] w-[190px] bg-bright-grey rounded' />
        </div>
      </td>
      <td className='whitespace-nowrap min-w-fit justify-items-end'>
        <div className='h-[28px] w-[119px] bg-bright-grey rounded' />
      </td>
    </tr>
  );
};
